import { render, staticRenderFns } from "./VisitTypes.vue?vue&type=template&id=2ed107ff&scoped=true&"
import script from "./VisitTypes.vue?vue&type=script&lang=js&"
export * from "./VisitTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed107ff",
  null
  
)

export default component.exports